// extracted by mini-css-extract-plugin
module.exports = {"left_column":"ForexTrading_left_column__CGkMg","right_column":"ForexTrading_right_column__i5mYb"};